export function getLoginErrorMessage(error: unknown): string {
  const message =
    (error as { message?: string })?.message ?? 'Unable to sign in';

  if (message === 'Failed to fetch') {
    return 'Unable to connect to the server. This may be caused by a browser extension such as an ad blocker, or a network issue. Try opening the page in an incognito window or check your connection.';
  }

  return message;
}
